import React, { forwardRef } from 'react';
import cx from 'classnames';
import styles from './index.module.scss.js';

const Thumb = forwardRef(
  ({
    className,
    style,
    image,
    text,
    icon,
    isActive,
    kind = "button",
    ...props
  }, forwardedRef) => /* @__PURE__ */ React.createElement(
    "button",
    {
      ...props,
      className: cx(styles.box, className, {
        [styles.active]: !!isActive,
        [styles[kind]]: kind
      }),
      style,
      type: "button",
      ref: forwardedRef
    },
    image && /* @__PURE__ */ React.createElement("img", { className: styles.image, src: image, alt: image }),
    text && /* @__PURE__ */ React.createElement("span", { className: styles.text }, text),
    icon || /* @__PURE__ */ React.createElement(
      "svg",
      {
        className: styles.arrow,
        width: "6",
        height: "4",
        viewBox: "0 0 6 4",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React.createElement(
        "path",
        {
          d: "M5.29917 0L0.700563 3.57354e-07C0.401051 3.80629e-07 0.222401 0.296715 0.388541 0.518234L2.68785 3.58397C2.83629 3.78189 3.16345 3.78189 3.31189 3.58397L5.61119 0.518233C5.77733 0.296715 5.59868 -2.32747e-08 5.29917 0Z",
          fill: "currentColor"
        }
      )
    )
  )
);
Thumb.displayName = "Popup.Thumb";

export { Thumb };
//# sourceMappingURL=index.js.map
